import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';

import IWall from 'components/interfaces/IWall';
import IWallMetaData from 'components/interfaces/IWallMetaData';
import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';
import { addMessage } from 'store/messages/actions';
import { setWall, setWallMetaData } from 'store/selectedWall/actions';

import EditWallButton from './EditWallButton';
import WallProperties from '../../../src/wallProperties/WallProperties';

import 'style/layout/Forms.css';

const EditWall = ({
  closeRightBar,
  disabledInputs,
}: {
  closeRightBar: () => void;
  disabledInputs?: boolean;
}): JSX.Element | null => {
  const dispatch = useDispatch();
  const selectedWall = useSelector((state: any) => state.selectedWall.raw);
  const wall = useSelector((state: any) => state.selectedWall.properties);
  const wallMetaData = useSelector((state: any) => state.selectedWall.metaData);

  return (
    <>
      <Row>
        <Col>
          <WallProperties
            action="edit"
            className="edit-fields"
            setWall={(updatedWall: IWall) =>
              dispatch(
                setWall({
                  ...updatedWall,
                  wallName: wallMetaData.name,
                })
              )
            }
            setWallMetaData={(updatedWallMetaData: IWallMetaData) => {
              dispatch(setWallMetaData(updatedWallMetaData));
              dispatch(
                setWall({
                  ...wall,
                  positionOffset: -wall.positionOffset,
                  wallName: updatedWallMetaData.name,
                })
              );
            }}
            wall={wall}
            wallMetaData={wallMetaData}
            disabledInputs={disabledInputs}
          />
        </Col>
      </Row>
      {!disabledInputs ? (
        <EditWallButton
          closeRightBar={closeRightBar}
          selectedWall={selectedWall}
        />
      ) : null}
    </>
  );
};

export default EditWall;
